import React, { Component } from 'react';
import JobsTable from './ui-components/jobsTable';
import ShownRowsInfoBlock from './ui-components/shownRowsInfoBlock';
import ShowMoreButton from './ui-components/showMoreButton';
import Filter from './ui-components/filter';
import Chips from "./ui-components/chips";
import Row from 'react-bootstrap/Row';

const API_URL = 'https://www.gotphoto.com/wp-json/recruitment/v1/open-positions';
const PAGE_SIZE = 5;

class Careers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shownRows: 5,
            selectedLocation: [],
            selectedDepartments: [],
            fetchedLocations: [],
            fetchedDepartments: [],
            jobs: []
        };
    }

    componentDidMount() {
        this.fetchData();
        this.setState({ shownRows: 5 });
    }

    fetchData = () => {
        fetch(API_URL)
            .then((response) => {
                if (response.status !== 200) {
                    console.error('Response status is not 200:', response.status);
                    return [];
                }
                return response.json();
            })
            .then((data) => {
                const locations = data['locations'].map((item) => ({
                    value: item.name,
                    label: item.name,
                }));
                this.setState({ fetchedLocations: locations });

                const departments = data['departments'].map((item) => ({
                    value: item.name,
                    label: item.name,
                }));
                this.setState({ fetchedDepartments: departments });

                const jobs = data['jobs'].map((job) => ({
                    id: job.id,
                    name: job.name,
                    department: job.department,
                    location: job.locations.join(', '),
                    url: job.url
                }));

                this.setState({ jobs: jobs });
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };

    showMoreRows = () => {
        this.setState((prevState) => ({
            shownRows: prevState.shownRows + PAGE_SIZE,
        }));
    };

    getFilteredJobs = () => {
        const { jobs, selectedLocation, selectedDepartments } = this.state;
        let result = jobs;

        if (selectedLocation.length !== 0) {
            result = this.filterLocations(result, selectedLocation);
        }

        if (selectedDepartments.length !== 0) {
            result = this.filterDepartments(result, selectedDepartments);
        }

        return  result;
    };

    filterLocations = (jobs, selectedLocation) => {
        return jobs.filter(job => selectedLocation.some(location => job.location.includes(location)));
    };

    filterDepartments = (jobs, selectedDepartments) => {
        return jobs.filter(job => selectedDepartments.includes(job.department));
    };

    handleRemoveLocation = (locationToRemove) => {
        this.setState((prevState) => ({
            selectedLocation: prevState.selectedLocation.filter(
                (location) => location !== locationToRemove
            ),
        }));
        this.setState({ shownRows: 5 });
    };

    handleRemoveDepartment = (departmentToRemove) => {
        this.setState((prevState) => ({
            selectedDepartments: prevState.selectedDepartments.filter(
                (departments) => departments !== departmentToRemove
            ),
        }));
        this.setState({ shownRows: 5 });
    };

    render() {
        const { shownRows, selectedLocation, selectedDepartments, jobs, fetchedLocations, fetchedDepartments } = this.state;

        if (jobs.length === 0) {
            return <div>No data</div>
        }

        return (
            <div>
                <div className="tw-inline-block tw-w-full tw-mb-4">
                    <Filter
                        allOptions={fetchedDepartments}
                        eventHandler={(selectedDepartments) => {
                            this.setState({selectedDepartments});
                            this.setState({shownRows: 5});
                        }
                        }
                        placeholder={<span className="career-filter-placeholder">Department</span>}
                        selectedOptions={selectedDepartments}
                        jobs={jobs.map((job) => job.department)}
                    />
                    <Filter
                        allOptions={fetchedLocations}
                        eventHandler={(selectedLocation) => {
                            this.setState({selectedLocation});
                            this.setState({shownRows: 5});
                        }
                        }
                        placeholder={<span className="career-filter-placeholder">Location</span>}
                        selectedOptions={selectedLocation}
                        jobs={jobs.map((job) => job.location)}
                    />
                </div>

                <Row className="tw-flex tw-mb-6">
                    <Chips
                        selectedValues={selectedLocation}
                        onRemoveValue={this.handleRemoveLocation}
                        allValues={fetchedLocations}
                    />
                    <Chips
                        selectedValues={selectedDepartments}
                        onRemoveValue={this.handleRemoveDepartment}
                        allValues={fetchedDepartments}
                    />
                </Row>

                <JobsTable
                    jobs={this.getFilteredJobs()}
                    shownRows={shownRows}
                />

                <ShownRowsInfoBlock
                    shownRows={shownRows}
                    total={this.getFilteredJobs().length}
                    pageSize={PAGE_SIZE}
                />
                <ShowMoreButton
                    shownRows={shownRows}
                    total={this.getFilteredJobs().length}
                    eventHandler={this.showMoreRows}
                />
            </div>
        )
    }
}

export default Careers;